export default "__VITE_ASSET__CqIm1hkK__"